import { styled } from "@mui/material/styles";
import { Container, Grid, Typography } from "@mui/material";

export const Root = styled(Container, {
  shouldForwardProp: (prop) => prop !== "isGrid",
})(({ isGrid }) => ({
  margin: "auto",
  ...(!isGrid && {
    margin: 0,
    padding: 0,
  }),
}));

export const StyledGrid = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "center",
})(({ center }) => ({
  display: "flex",
  marginBottom: 40,
  ...(center && {
    justifyContent: "center",
  }),
}));

export const ContentScroll = styled(Container)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  flexWrap: "nowrap",
  alignItems: "center",
  justifyContent: "start",
  overflow: "auto",
  padding: "15px 0 20px",
  [theme.breakpoints.up("mobile")]: {
    padding: "30px 0",
  },
  [theme.breakpoints.up("tablet")]: {
    padding: "30px 0 60px",
  },
}));

export const ItemScrolleable = styled(Container)(({ theme }) => ({
  width: "38%",
  minWidth: "38%",
  margin: 10,
  padding: "0 !important",
  [theme.breakpoints.up("mobile")]: {
    width: "21%",
    minWidth: "21%",
  },
  [theme.breakpoints.up("tablet")]: {
    width: 190,
    minWidth: 190,
  },
}));

export const Title = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "isGrid",
})(({ theme, isGrid }) => ({
  textAlign: "center",
  ...(isGrid
    ? {
        marginBottom: 8,
        [theme.breakpoints.up("tablet")]: {
          textAlign: "left",
          marginBottom: 28,
        },
      }
    : {
        margin: 0,
      }),
}));
